// @flow

import {Tag} from 'docs/util';

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const SupportedTaxIdTable: MarkdocTagRegistration = {
  tag: 'supported-tax-id-table',
  component: 'SupportedTaxIdTable',
  render(node, config) {
    const taxProduct = (config.variables.taxProduct: any);
    return new Tag(this.tag, {entries: taxProduct?.tax_id_table});
  },
};
